import { literal, union } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const AssigneeType = union(
	iotsUtils.fromList([...constants.transaction.stage.reportIds]),
	literal('total')
);
